var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordTableReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.25006C7.67525 3.25006 3.75 7.17526 3.75 11.9999C3.75 16.8249 7.67525 20.7501 12.5 20.7501C17.3247 20.7501 21.25 16.8249 21.25 11.9999C21.25 7.17526 17.3247 3.25006 12.5 3.25006ZM12.4999 23.0001C6.4346 23.0001 1.5 18.0655 1.5 11.9999C1.5 5.93466 6.4346 1.00006 12.4999 1.00006C18.5652 1.00006 23.4998 5.93466 23.4998 11.9999C23.4998 18.0655 18.5652 23.0001 12.4999 23.0001Z",
    fill: "#003C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0922 11.288C16.7336 11.6774 16.7336 12.6082 16.0922 12.9976L11.0191 16.0777C10.3527 16.4824 9.50011 16.0026 9.50011 15.223L9.50011 9.06272C9.50011 8.28308 10.3527 7.80332 11.0191 8.20793L16.0922 11.288Z",
    fill: "#003C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordTableReplay);
export default __webpack_public_path__ + "static/media/recordTableReplay.22a26be4cf4db34eca729ab4b29b937b.svg";
export { ForwardRef as ReactComponent };